import React, { FC } from 'react';
import { MainValue, Value } from '../components';
import { WidgetDataColour } from './colours';

export const PercentageData: FC<{ value: number }> = ({ value }) => {
  const color = value < 80 ? WidgetDataColour.Red : WidgetDataColour.Green;

  return (
    <Value>
      <MainValue color={color}>{value.toFixed(1)}%</MainValue>
    </Value>
  );
};
